export default {
	props: {
		//Tab to load, passed in from route
		tab: {
			type: String,
			default: '',
		}
	},
	data() {
		return {
			loadedTabs: [],
			tabRoute: null,
			tabParams: {},
			currentTab: null,
			defaultTab: null, //Tab to load when tab prop is empty
		}
	},
	methods: {
		onTabChange(tabIndex, newTab, oldTab) {
			let id = newTab._props.id; //Get id attribute

			this.loadTab(id);

			//Update url
			if(this.tabRoute) {
				this.$router.replace(this.getTargetRoute({
					...this.tabParams,
					name: this.tabRoute,
					params: {tab: id === this.defaultTab ? null : id},
				}));
			}
		},

		//Allow other mixins to edit route
		getTargetRoute(route) {
			return route;
		},

		//By default, try to call the load() method on a component with a ref matching the tab id
		loadTab(id) {
			//If not already loaded, load it
			if(this.loadedTabs.indexOf(id) === -1) {
				if(this.$refs[id] && this.$refs[id].load) {
					this.$refs[id].load();
				}

				this.loadedTabs.push(id);
			}
		},

		switchTab(id) {
			let tabs = this.$refs.tabs.getTabs(),
				tab = tabs.findIndex((tab) => tab.componentInstance._props.id === id); //Get tab by id attribute

			if(id === this.currentTab) {
				return;
			}

			if(tab > -1) {
				this.$refs.tabs.findTabAndActivate(tab);
				this.loadTab(id);
				this.currentTab = id;
			}
		}
	},
	mounted() { //Switch to correct tab on load
		this.switchTab(this.tab || this.defaultTab);
	},
	beforeRouteUpdate(to, from, next) {
		this.switchTab(to.params.tab || this.defaultTab);
		next();
	},
}
